import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'csa-claiming-bottomsheet',
  templateUrl: './claiming-bottomsheet.component.html',
  styleUrls: ['./claiming-bottomsheet.component.scss'],
  standalone: false,
})
export class ClaimingBottomsheetComponent {
  constructor(
    public bottomsheet: MatBottomSheetRef<ClaimingBottomsheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

  close(): void {
    this.bottomsheet.dismiss();
  }

  handleContinue(): void {
    const { enableContinue } = this.data;
    this.bottomsheet.dismiss(enableContinue);
  }
}
